/**
 * UL-7912 -- what the CPM cell makes of what was typed into it.
 *
 * Blank clears the CPM (null). Anything else must be a non-negative number. `unchanged` compares
 * numerically, because the API sends CPM as a 4dp decimal string (`'12.5000'`).
 */
export type CpmInput = {
    /** The CPM to save: null to clear it. NaN when the text is not a number. */
    parsed: number | null;
    invalid: boolean;
    unchanged: boolean;
};

export const parseCpmInput = (value: string | number, current: string | null): CpmInput => {
    const trimmed = String(value).trim();
    const parsed = trimmed === '' ? null : Number(trimmed);
    const invalid = parsed !== null && (Number.isNaN(parsed) || parsed < 0);
    const unchanged =
        (current === null && parsed === null) || (current !== null && parsed === Number(current));

    return { parsed, invalid, unchanged };
};
